import styled from 'styled-components';
import {theme, fontStyles} from '@styles/theme';

export const SelectDateInputWrapper = styled.div`
  position: relative;
  border-radius: 12px;
  background-color: ${theme.colors.basic08};
  border: 1px solid ${theme.colors.basic06};
  width: 560px;
  max-width: 100%;
  box-sizing: border-box;
  .react-calendar__tile {
    transition: none;
    box-sizing: border-box;
    border: 2px solid transparent;
    padding: 6px 8px;
    position: relative;
  }

  .react-calendar__tile:disabled,
  .react-calendar__tile--disabled {
    background: transparent !important;
    color: ${theme.colors.basic03} !important;
    cursor: default !important;
    opacity: 1;
    text-decoration: none;
  }

  .react-calendar__tile.planned-future:not(.react-calendar__tile--rangeStart):not(
      .react-calendar__tile--rangeEnd
    )::after {
    content: '';
    position: absolute;
    top: 4px;
    right: 0px;
    width: 6px;
    height: 6px;
    border-radius: 50%;
    background: ${theme.colors.signalOrange00};
  }

  .react-calendar__tile.planned-future.react-calendar__tile--rangeStart,
  .react-calendar__tile.planned-future.react-calendar__tile--rangeEnd,
  .react-calendar__tile.planned-future.react-calendar__tile--active {
    background: ${theme.colors.signalOrange00} !important;
    color: ${theme.colors.basic08} !important;
  }

  .react-calendar__tile--now:not(.react-calendar__tile--rangeStart):not(
      .react-calendar__tile--rangeEnd
    ) {
    background: transparent !important;
    border: 2px solid ${theme.colors.accent00} !important;
    color: ${theme.colors.accent00} !important;
  }

  .react-calendar__tile--range:not(.react-calendar__tile--rangeStart):not(
      .react-calendar__tile--rangeEnd
    ):not(.react-calendar__tile--disabled):not(:disabled) {
    background: transparent !important;
    color: inherit !important;
    box-shadow: none !important;
  }

  .react-calendar__tile--range.react-calendar__tile--disabled,
  .react-calendar__tile--range:disabled {
    background: transparent !important;
    color: ${theme.colors.basic03} !important;
    box-shadow: none !important;
    cursor: default !important;
  }

  .react-calendar__tile--range.disabled-past {
    background: ${theme.colors.basic07} !important;
    color: ${theme.colors.basic03} !important;
  }

  .react-calendar__tile--rangeStart,
  .react-calendar__tile--rangeEnd {
    background: ${theme.colors.accent00} !important;
    color: ${theme.colors.basic08} !important;
    box-shadow: none !important;
  }

  .react-calendar__tile--active:not(.react-calendar__tile--rangeStart):not(
      .react-calendar__tile--rangeEnd
    ):not(.react-calendar__tile--disabled):not(:disabled) {
    background: transparent !important;
    color: inherit !important;
    box-shadow: none !important;
  }

  .react-calendar__tile:enabled:hover:not(.react-calendar__tile--rangeStart):not(
      .react-calendar__tile--rangeEnd
    ) {
    background: transparent !important;
    box-shadow: none !important;
  }

  .react-calendar__tile--hover:not(.react-calendar__tile--rangeStart):not(
      .react-calendar__tile--rangeEnd
    ):not(.react-calendar__tile--active):not(.react-calendar__tile--disabled):not(
      :disabled
    ) {
    background: transparent !important;
    box-shadow: none !important;
  }

  .react-calendar__tile--disabled,
  .react-calendar__tile:disabled {
    background: transparent !important;
    color: ${theme.colors.basic03} !important;
    box-shadow: none !important;
    cursor: default !important;
  }

  /* Hover effect on disabled tiles: show active text color */
  .react-calendar__tile--disabled:hover,
  .react-calendar__tile:disabled:hover,
  .react-calendar__tile--range.react-calendar__tile--disabled:hover,
  .react-calendar__tile--range:disabled:hover,
  .react-calendar__tile--disabled.disabled-past:hover,
  .react-calendar__tile:disabled.disabled-past:hover {
    color: ${theme.colors.basic01} !important;
  }

  /* Past disabled tiles: keep muted background overriding generic disabled */
  .react-calendar__tile--disabled.disabled-past,
  .react-calendar__tile:disabled.disabled-past {
    background: ${theme.colors.basic07} !important;
    color: ${theme.colors.basic03} !important;
  }

  .react-calendar__tile--range.disabled-past,
  .react-calendar__tile--active.disabled-past,
  .react-calendar__tile--hover.disabled-past {
    background: ${theme.colors.basic07} !important;
    color: ${theme.colors.basic03} !important;
  }

  .react-calendar--doubleView {
    width: 100%;
    max-width: 100%;
  }
  .react-calendar__viewContainer {
    display: flex;
  }
  .react-calendar__viewContainer > * {
    width: 50%;
  }
  .react-calendar__viewContainer > *:first-child {
    border-right: 1px solid ${theme.colors.basic06};
    margin-right: 0px;
  }

  .react-calendar__viewContainer > *:last-child {
    margin-left: 0px;
  }

  .react-calendar__navigation {
    display: none;
    margin-bottom: 0px;
  }

  .react-calendar__month-view__weekdays {
    ${fontStyles.tinyR}
    color: ${theme.colors.basic01};
    text-transform: none;
    border-top: 1px solid ${theme.colors.basic06};
  }
  .react-calendar__month-view__weekdays__weekday {
    ${fontStyles.tinyR}
    color: ${theme.colors.basic01};
    padding: 8px 0;
  }
  .react-calendar__month-view__weekdays__weekday abbr {
    text-decoration: none;
    text-transform: capitalize;
  }

  .react-calendar
    .react-calendar__month-view
    .react-calendar__month-view__days
    .react-calendar__month-view__days__day.react-calendar__tile {
    ${fontStyles.tinyNum}
    &:hover {
      background: ${theme.colors.accent02} !important;
      color: ${theme.colors.basic01} !important;
    }
  }

  .react-calendar {
    border: 0;
    background-color: transparent;
  }
`;

export const TodayBar = styled.div`
  ${fontStyles.captionB}
  color: ${theme.colors.basic01};
  padding: 16px 24px;
  text-align: start;
  border-bottom: 1px solid ${theme.colors.basic06};
`;

export const TodayBarSides = styled.div`
  display: grid;
  grid-template-columns: 1fr auto 1fr;
  align-items: center;
  width: 100%;
  column-gap: 12px;
  & > span:first-child {
    justify-self: start;
    text-align: left;
  }
  & > span:nth-child(2) {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 4px;
  }
  & > span:last-child {
    justify-self: end;
    text-align: right;
  }
`;

export const TodayBarRightMuted = styled.span`
  color: ${theme.colors.basic04};
`;

export const CalendarHeadersRow = styled.div`
  display: grid;
  grid-template-columns: 28px 1fr 1fr 28px;
  align-items: center;
  width: 100%;
  max-width: 100%;
  box-sizing: border-box;
  min-width: 0;
  overflow: hidden;
  padding: 0px 16px;
`;

export const CalendarHeaderCell = styled.div`
  ${fontStyles.bodyM};
  text-align: center;
  text-transform: capitalize;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  &:first-of-type {
    border-right: 1px solid ${theme.colors.basic06};
  }
  padding: 16px 0px;
`;

export const CalendarNavButton = styled.button<{disabled?: boolean}>`
  ${fontStyles.bodyM}
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border: 0;
  background-color: ${theme.colors.basic08};
  cursor: pointer;
`;

export const BottomActionBar = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 12px 16px;
  border-top: 1px solid ${theme.colors.basic06};
  background-color: ${theme.colors.basic08};
  border-radius: 0 0 12px 12px;
`;
